import useYearList from './use-year-list';

//Siva need to conditionally show next/other years.
//This file allows that without polluting useyearList
const useSivaYearList = (lowerYear: number) => {
  const date = new Date();
  date.setMonth(date.getMonth() + 1);
  const upperYear = date.getFullYear();

  return useYearList(lowerYear, upperYear);
};

export default useSivaYearList;
